import React, {Component} from 'react';
import Masonry from 'react-masonry-component';
import PropTypes from 'prop-types';
import getTeaserTile from '../../services/contentType';


export default class TeaserList extends Component {

    static propTypes = {
        teasers: PropTypes.array,
        favouriteLink: PropTypes.string
    };

    render() {
        const teasers = this.props.teasers.map((teaser, index) => {
            const TeaserTile = getTeaserTile(teaser.contentType);
            return <TeaserTile key={index} id={index} teaser={teaser} favouriteLink={this.props.favouriteLink} />
        });

        const masonryOptions = {
            gutter: 30,
            columnWidth: '.layoutTeaserDefault'
        };

        return (
            <Masonry className={'teaserList'} options={masonryOptions}>
                {teasers}
            </Masonry>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/TeaserList/TeaserList.js